@use "ui/styles/colors";
@use "ui/styles/sizes";

.planName {
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: sizes.$s5;

  :global {
    .location {
      display: block;
      flex: 1 1 auto;
      min-width: 0;

      .name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .parent {
        font-style: italic;
        color: colors.$brandDarkGray;
      }
    }
  }
}
